import moment from 'moment';
import queryString from 'qs';

const getReportOperatorsRequest = (filter) => {
  const queries = { limit: 10, page: filter?.page };

  if (filter?.search) queries['search'] = filter.search;
  if (filter?.monthYear) queries['monthYear'] = moment(filter.monthYear).format('MM-YYYY');

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportOperatorsRequest;
